import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from '@reach/router';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import {
	DataGrid,
    Column,
    Button,
    SearchPanel,
    FilterRow,
    HeaderFilter,
    ColumnChooser,
	Export,
	Grouping,
	GroupPanel,
	Selection
} from 'devextreme-react/data-grid';

import { ExcelJS , Workbook } from "exceljs";
import saveAs from "file-saver";
import { exportDataGrid as exportDataGridToExcel } from "devextreme/excel_exporter";

import CustomStore from 'devextreme/data/custom_store';
import DeleteIcon from '@material-ui/icons/Delete';
import FlipToFrontIcon from '@material-ui/icons/FlipToFront';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import { updTemplateStatus } from '../../../apis/template/templates'
import Switch from '@material-ui/core/Switch';

import { getTemplatesList , delTemplate } from '../../../apis/template/templates';
import { triggerDialog , setLoading , triggerNotification } from '../../../actions';
import { translationHook } from '../../translationHook';
import {
	ButtonPrimary,
	ButtonSecondary,
	ButtonDanger,
	ButtonInfo,
	ButtonWarning,
} from '../../UI/Buttons';

class ModulesList extends Component {
	constructor(props){
		super(props);
		this.onExporting = this.onExporting.bind(this);
	}
	customizeCellCheckbox = ({data}) => {
        return (
            <Switch
			checked={data.Active_Status_Id}
			name={`templateStatus_${data.Template_Id}`}
			onChange={async () => {
				let at = this.props.currentUser.Data.access_token,
					templateId = data.Template_Id,
					status = data.Active_Status_Id ? 0 : 1

					this.props.setLoading(true, 'dark')

					const response = await updTemplateStatus(at, templateId, status)

					this.props.triggerNotification(true, response)
					this.props.setLoading(false)
			}}
			/>
        )
    }
	
	// delete dropdown
	handleDelete = (data) => {
		let at = this.props.currentUser.Data.access_token,
			templateId = data.Template_Id,
			templateName =
				this.props.i18n.language === 'ar'
					? data.Template_Name_AR
					: data.Template_Name_EN,
			dialogTitle = `${this.props.t('confirmDeleteTitle')} ${templateName}`,
			dialogMsg = this.props.t('confirmDeleteMsg');

		this.props.triggerDialog(true, {
			title: dialogTitle,
			message: dialogMsg,
			action: {
				action: delTemplate,
				params: [
					at,
					templateId,
				],
				text: this.props.t('delete'),
			},
		});
	};

	render() {
		let columnAlign = 'left',
			at = this.props.currentUser.Data.access_token;

		if (this.props.i18n.language === 'ar') {
			columnAlign = 'right';
		}

		const jsonDataSource = new CustomStore({
			key: 'Template_Id',
			load: () => {
				return getTemplatesList(at);
			},
		});

		return (
			<>
				<div className='d-flex justify-content-between align-items-center mb-4'>
					<h3>{this.props.t('manageModules')}</h3>
					<ButtonPrimary component={Link} to='add-module' size='large'>
						{this.props.t('addModule')}
					</ButtonPrimary>
				</div>

				<DataGrid
					className={[this.props.i18n.language === 'ar' ? 'dx-grid-ar' : 'dx-grid-en' , 'globalBox'].join(' ')}
					id="dataGrid"
					width={'100%'}
					dataSource={jsonDataSource}
					showBorders={false}
					showColumnLines= {false}
					showRowLines= {true}
					allowColumnResizing={true}
					columnResizingMode={'widget'}
					allowColumnReordering={true}
					rowAlternationEnabled={false}
					focusedRowEnabled={true}
					onExporting={this.onExporting}
					columnWidth={'auto'}
					wordWrapEnabled={true}
					rtlEnabled={this.props.i18n.language === 'ar' ? true : false}
				>

					<ColumnChooser enabled={true} allowSearch={true} search={'fff'}
						title={this.props.t('dxColumnChooserTitle')}
						emptyPanelText={this.props.t('dxColumnChooserPanelText')}
					/>
					
					<SearchPanel 
						visible={true}
						width={240}
						placeholder={this.props.t('search')}
					/>

					<FilterRow visible={true} />

					<HeaderFilter visible={true} />

					<Export enabled={true} allowExportSelectedData={true}/>

					<Grouping contextMenuEnabled={true} expandMode="rowClick"/>
                	<GroupPanel visible={true} emptyPanelText={this.props.t('dxGroupPanelText')}/>

					<Selection
						mode="multiple"
						selectAllMode={'allPages'}
						showCheckBoxesMode={'always'}
					/>

					<Column
						dataField={'Template_Name_AR'}
						caption={this.props.t('ModuleNameAR')}
						alignment={columnAlign}>
					</Column>
					<Column
						dataField={'Template_Name_EN'}
						caption={this.props.t('ModuleNameEN')}
						alignment={columnAlign}>
					</Column>


					<Column
						dataField='Active_Status_Id'
						caption={this.props.t('serviceStatus')}
						cellRender={this.customizeCellCheckbox}
						allowFiltering={false}
						alignment={'center'}>
					</Column>

					<Column cssClass="outlinedColumn nowrapColumn"
						type='buttons'
						caption={this.props.t('details')}
						fixed={true}
						fixedPosition={this.props.i18n.language === 'ar' ? 'left' : 'right'}
					>
						<Button
						render={(record) => {
							return (
								
								<ButtonWarning
								variant="circleIcon"
								startIcon={<EditIcon />}
								component={Link}
								to={`edit-module/${record.data.Template_Id}`}
								>
									{/* {this.props.t('edit')} */}
								</ButtonWarning>
							)
						}}
						/>
						<Button
						render={(record) => {
							return (
								
								<ButtonInfo
								variant="circleIcon"
								startIcon={<VisibilityIcon />}
								component={Link}
								to={`edit-module/${record.data.Template_Id}/#view`}
								>
									{/* {this.props.t('view')} */}
								</ButtonInfo>
							)
						}}
						/>

						<Button
							render={(record) => {
								return (
									<ButtonDanger
										variant='circleIcon'
										startIcon={<DeleteIcon />}
										onClick={() => this.handleDelete(record.data)}>
										{/* {this.props.t('delete')} */}
									</ButtonDanger>
								);
							}}
						/>
					</Column>
				</DataGrid>
			</>
		);
	}
	onExporting(e) {
		let sheetTitle = this.props.t('manageModules')
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGridToExcel({
            component: e.component,
            worksheet: worksheet,
			autoFilterEnabled: true,
			topLeftCell: { row: 2, column: 2 },
			topRightCell: { row: 2, column: 2 },
            customizeCell: ({gridCell, excelCell}) => {
                // excelCell.value = gridCell.value;
                excelCell.font = { family: 2, name: 'Cairo', size: 10, color: {argb: "151713"} };
				excelCell.alignment = { indent: 1, wrapText: true, vertical: 'middle' };
				if(gridCell.rowType === 'group') {
					excelCell.fill = {
						type: 'pattern',
						pattern:'solid',
						fgColor:{argb:'d0b166'}
					  };
					excelCell.alignment = { indent: 2 };
					excelCell.font = { family: 2, name: 'Cairo', size: 10, color: {argb: "ffffff"}, bold: true };
				}
				if(gridCell.rowType === 'header') {
				excelCell.fill = {
					type: 'pattern',
					pattern:'solid',
					fgColor:{argb:'58743a'}
					};
				excelCell.alignment = { vertical: 'middle', horizontal: 'center' };
				excelCell.font = { family: 2, name: 'Cairo', size: 12, color: {argb: "ffffff"}, bold: true };
				}
            } 
        }).then(function() {
            workbook.xlsx.writeBuffer()
                .then(function(buffer) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${sheetTitle}.xlsx`);
                });
        });
        e.cancel = true;
    }
}

const mapStateToProps = (state) => {
	return {
		currentUser: state.currentUser,
		reload: state.reload,
	};
};

export default connect(mapStateToProps, { triggerDialog, setLoading , triggerNotification })(
	translationHook(ModulesList)
);
